module.exports = __webpack_public_path__ + "img/banner-bg.dec701e1.jpg";